const state = {
  app: null,
  usuario: false,
  formSaved: null,
  formSavedTicket: null,
  formConfigHtl: null,
  buscando: false,
  openLatBus: false,
  appAll: [
    {
      titulo: "Tickets",
      icons: ["fas fa-ticket-alt"],
      // ruta: "http://localhost:9000",
      ruta: "https://www.allseasons.tur.ar/ws/apps_new/#/tickets",
      apps: [
        {
          id: 14,
          nombre: "Walt Disney World",
          nombreCorto: "Tickets",
          ruta: "pases",
          subtittle: "",
          icons: ["fas fa-ticket-alt"]
        }
      ]
    },
    {
      titulo: "Walt Disney World",
      ruta: "https://www.allseasons.tur.ar/ws/apps_new/#/",
      // ruta: "http://localhost:9000",
      icons: ["fab fa-fort-awesome"],
      apps: [
        {
          id: 13,
          nombre: "Parque temáticos",
          nombreCorto: "Disney",
          ruta: "orlandoDc",
          subtittle: "",
          icons: ["fab fa-fort-awesome"]
        }
      ]
    },
    {
      titulo: "Universal Studios",
      icons: ["fas fa-globe-americas"],
      ruta: "universal",
      apps: [
        {
          id: 19,
          nombre: "Universal Studios",
          nombreCorto: "Universal",
          ruta: "universal",
          subtittle: "",
          icons: ["fas fa-globe-americas"]
        }
      ]
    },
    {
      titulo: "Alojamiento",
      ruta: "ebooking",
      icons: ["fas fa-concierge-bell"],
      apps: [
        {
          id: 12,
          nombre: "Hoteleria",
          nombreCorto: "Alojamiento",
          ruta: "ebooking",
          subtittle: "",
          icons: ["fas fa-concierge-bell"]
        }
      ]
    },
    {
      titulo: "Cupos Aéreos",
      icons: ["fas fa-plane-departure"],
      ruta: "cuposAereosSolo",
      apps: [
        {
          id: 11,
          nombre: "Cupos Aéreos",
          nombreCorto: "Cupos",
          ruta: "cuposAereosSolo",
          subtittle: "",
          icons: ["fas fa-clipboard-list"]
        },
        {
          id: 11,
          nombre: "Visualización Rapida",
          nombreCorto: "Cupos",
          ruta:
            "https://docs.google.com/spreadsheets/d/e/2PACX-1vT6BNouD-Z8VOJqFb8ixB-Ei9YgWUveMJ9BTBjHuJulDvwMKb0WTEtjtVmg1ZxaeA/pubhtml",
          subtittle: "",
          icons: ["fas fa-clipboard-list"]
        }
      ]
    },
    {
      titulo: "Cruceros",
      icons: ["fas fa-anchor"],
      ruta: "cruceros",
      apps: [
        {
          id: 0,
          nombre: "Cruceros",
          nombreCorto: "Cruceros",
          ruta: "cruceros",
          subtittle: "",
          icons: ["fas fa-anchor"]
        }
      ]
    },
    {
      titulo: "Autos",
      icons: ["fas fa-car-alt"],
      ruta: "https://www.allseasons.tur.ar/ws/apps_new/#/autos",
      apps: [
        {
          id: 0,
          nombre: "Autos",
          nombreCorto: "Autos",
          ruta: "",
          subtittle: "",
          icons: ["fas fa-car-alt"]
        }
      ]
    },
    {
      titulo: "Cupo + Hotel",
      ruta: "cuposAereos",
      icons: ["fas fa-plane-departure", "fas fa-concierge-bell"],
      apps: [
        {
          id: 3,
          nombre: "Cupos + Hoteles",
          nombreCorto: "Hotel + Cupo",
          ruta: "cuposAereos",
          subtittle: "",
          icons: [
            "fas fa-plane-departure",
            "fas fa-concierge-bell",
            "directions_bus"
          ]
        }
      ]
    },
    {
      titulo: "Paquetes",
      ruta: "paquetes",
      icons: ["fas fa-shopping-bag"],
      apps: [
        {
          id: 0,
          nombre: "Paquetes",
          nombreCorto: "Paquetes",
          ruta: "paquetes",
          subtittle: "",
          icons: ["fas fa-shopping-bag"]
        }
      ]
    },
    {
      titulo: "Asistencia",
      icons: ["fas fa-medkit"],
      ruta: "https://www.allseasons.tur.ar/ws/apps_new/#/asistencia",
      apps: [
        {
          id: 0,
          nombre: "Asistencia",
          nombreCorto: "Asistencia",
          ruta: "",
          subtittle: "",
          icons: ["fas fa-medkit"]
        }
      ]
    },
    {
      titulo: "Tarifario",
      ruta: "tarifario",
      icons: ["fas fa-clipboard-list"],
      apps: [
        {
          id: 11,
          nombre: "Tarifarios Off Line",
          nombreCorto: "Tarifario",
          ruta: "tarifario",
          subtittle: "",
          icons: ["fas fa-clipboard-list"]
        }
      ]
    }
  ],
  regiones: [
    { nombre: "Sudamérica", key: "sudamerica" },
    { nombre: "Caribe", key: "caribe" },
    { nombre: "Sudamérica", key: "sudamerica" },
    { nombre: "Norteamérica", key: "norteamerica" },
    { nombre: "Europa", key: "europa" },
    { nombre: "Asia", key: "asia" }
  ]
};
const getters = {
  getUsuario: state => {
    return state.usuario;
  },
  getApp: state => {
    return state.app;
  },
  getFormConfigHtl: state => {
    return state.formConfigHtl;
  },
  getAllApp: state => {
    return state.appAll;
  },
  isBuscando: state => {
    return state.buscando;
  },
  getFormSaved: state => {
    return state.formSaved;
  },
  getFormSavedTicket: state => {
    return state.formSavedTicket;
  },
  getOpenLatBus: state => {
    return state.openLatBus;
  },
  getRegiones: state => {
    return state.regiones;
  }
};
const actions = {
  guardarUsuario({ commit }, item) {
    commit("setUsuario", item);
  },
  saveApp({ commit }, item) {
    item["imgFooter"] = `https://www.allseasons.tur.ar/ws/utiles/img/${
      item.cliente_id
    }/footer_logos.jpg`;
    commit("setApp", item);
  },
  saveFormConfigHtl({ commit }, item) {
    commit("setFormConfigHtl", item);
  },
  saveOcupacionForm({ commit }, item) {
    commit("setOcupacionForm", item);
  },
  actionModificarHabs({ commit }, item) {
    commit("setModificarHabs", item);
  },
  actionModificarAld({ commit }, item) {
    commit("setModAdl", item);
  },
  actionModificarChds({ commit }, item) {
    commit("setModAdlChds", item);
  },
  actionModificarEdadChds({ commit }, item) {
    commit("setModEdadChds", item);
  },
  setBuscando({ commit }, item) {
    commit("modBuscando", item);
  },
  setFormSave({ commit }, item) {
    commit("modFormSaved", item);
  },
  saveToApp({ commit }, item) {
    commit("guardarApp", item);
  },
  setFormSaveTicket({ commit }, item) {
    commit("modFormSavedTicket", item);
  },
  setLatBus({ commit }, item) {
    commit("modLatBus", item);
  }
};
const mutations = {
  setUsuario(state, usuario) {
    state.usuario = usuario;
  },
  setApp(state, item) {
    state.app = item;
  },
  setFormConfigHtl(state, item) {
    state.formConfigHtl = item;
  },
  setOcupacionForm(state, item) {
    state.formConfigHtl["ocupacion"] = item.ocupacion;
  },
  setModificarHabs(state, item) {
    if (
      (state.formConfigHtl.ocupacion.length === 1 && item === "r") ||
      (state.formConfigHtl.ocupacion.length === 3 && item === "s")
    ) {
      return;
    }
    if (item === "s") {
      state.formConfigHtl.ocupacion.push({ adultos: 2, edades: [] });
    } else {
      state.formConfigHtl.ocupacion.pop();
    }
  },
  setModAdl(state, item) {
    if (
      (state.formConfigHtl.ocupacion[item.indice].adultos === 1 &&
        item.operacion === "r") ||
      (state.formConfigHtl.ocupacion[item.indice].adultos === 4 &&
        item.operacion === "s")
    ) {
      return;
    }
    let adultos = state.formConfigHtl.ocupacion[item.indice].adultos;
    if (item.operacion === "s") {
      adultos++;
      state.formConfigHtl.ocupacion[item.indice].adultos = adultos;
    } else {
      adultos--;
      state.formConfigHtl.ocupacion[item.indice].adultos = adultos;
    }
  },
  setModAdlChds(state, item) {
    if (
      (state.formConfigHtl.ocupacion[item.indice].edades.length === 0 &&
        item.operacion === "r") ||
      (state.formConfigHtl.ocupacion[item.indice].edades.length === 3 &&
        item.operacion === "s")
    ) {
      return;
    }
    if (item.operacion === "s") {
      state.formConfigHtl.ocupacion[item.indice].edades.push({ edad: 0 });
    } else {
      state.formConfigHtl.ocupacion[item.indice].edades.pop();
    }
  },
  setModEdadChds(state, item) {
    let edad =
      state.formConfigHtl.ocupacion[item.indexhab].edades[item.indexchd].edad;
    if (
      item.operacion === "s" &&
      state.formConfigHtl.ocupacion[item.indexhab].edades[item.indexchd].edad <=
        16
    ) {
      edad++;
      state.formConfigHtl.ocupacion[item.indexhab].edades[
        item.indexchd
      ].edad = edad;
    } else if (
      item.operacion === "r" &&
      state.formConfigHtl.ocupacion[item.indexhab].edades[item.indexchd].edad >=
        1
    ) {
      edad--;
      state.formConfigHtl.ocupacion[item.indexhab].edades[
        item.indexchd
      ].edad = edad;
    } else {
      state.formConfigHtl.ocupacion[item.indexhab].edades[
        item.indexchd
      ].edad = 0;
    }
  },
  setEdadChd(state, item) {
    state.formConfigHtl.ocupacion[item.indexhab].edades[item.indexchd].edad =
      item.edad;
  },
  modBuscando(state, item) {
    state.buscando = item;
  },
  modFormSaved(state, item) {
    state.formSaved = item;
  },
  guardarApp(state, item) {
    const indice = state.appAll.findIndex(a => a.titulo === item.nombre);
    state.appAll[indice].apps.push(item.app);
  },
  modFormSavedTicket(state, item) {
    state.formSavedTicket = item;
  },
  modLatBus(state, item) {
    state.openLatBus = item;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
